import React from "react";
import { Button } from "@chakra-ui/react";
import { CheckIcon, SmallCloseIcon } from "@chakra-ui/icons";

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  isConfirmDisabled?: boolean;
}

const GaraazApproveReject: React.FC<Props> = ({
  onConfirm,
  onCancel,
  isConfirmDisabled,
}) => {
  return (
    <>
      <Button
        style={{
          borderRadius: "4px",
          width: "15px",
          height: "20px",
          backgroundColor: "#fd1f1f",
          color: "white",
          fontWeight: "bold",
        }}
        padding={1}
        size={"xs"}
        fontSize={"lg"}
        onClick={onCancel}
      >
        <SmallCloseIcon />
      </Button>
      <Button
        disabled={isConfirmDisabled}
        style={{
          borderRadius: "4px",
          width: "15px",
          height: "20px",
          backgroundColor: "#00bc6b",
          color: "white",
          fontWeight: "bold",
        }}
        padding={1}
        size={"xs"}
        fontSize={"sm"}
        onClick={onConfirm}
      >
        <CheckIcon fontSize="inherit" />
      </Button>
    </>
  );
};

export default GaraazApproveReject;
